<template>
    <a-modal class="modal-new my-confirm" :class="mode" :style="{'--modal-top': modalTop}" :visible="visible" :width="400" :title="null" :footer="null" :closable="closable" @cancel="handleClose">
        <div class="modal-content">
            <div class="confirm-title">
                <i class="icon" :class="icon" v-if="icon" />
                <span class="info-main">{{ title }}</span>
            </div>
            <div class="confirm-info" :class="[infoAlign]">
                <div class="input-container">
                    <slot name="input"></slot>
                </div>
                <div class="info-tip">
                    <slot name="tip"></slot>
                </div>
            </div>
            <div class="confirm-footer">
                <slot name="btn-area"></slot>
            </div>
        </div>
    </a-modal>
</template>

<script>
export default {
    name: 'MyConfirm',
    props: {
        visible: { type: Boolean, default: false },
        icon: { type: String, default: 'i-warning-new' },
        title: { type: String, default: '' },
        tip: { type: String, default: '' },
        closable: { type: Boolean, default: true },
        infoAlign: { type: String, default: 'center' },
        mode: { type: String, default: '' }, // 'danger'
        modalTop: { type: String, default: '100px' },
    },   
    methods: {
        handleClose() {
            this.$emit('close')
        }
    }, 
}
</script>
<style lang="scss" scoped>
</style>